import { render, staticRenderFns } from "./noticeDetails.vue?vue&type=template&id=6581011b&scoped=true&"
import script from "./noticeDetails.vue?vue&type=script&lang=js&"
export * from "./noticeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6581011b",
  null
  
)

export default component.exports